module.exports = __webpack_public_path__ + "img/image32.4384b622.png";